import React from 'react';
import { SignatureDocument } from 'src/signature/stores/signature.store';
import { DesktopSignModal } from '../sign-modal/desktop-sign-modal';
import { MobileSignModal } from '../sign-modal/mobile-sign-modal';

export interface SignatureProps {
    document: SignatureDocument;
    open: boolean;
    handleClose: () => void;
}

export const Signature: React.FC<SignatureProps> = (props: SignatureProps) => {
    const { document, open, handleClose } = props;

    const isTouchScreen = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const SignModalComponent = isTouchScreen ? MobileSignModal : DesktopSignModal;

    return <SignModalComponent document={document} open={open} handleClose={handleClose} />;
};
